import React, { Component } from 'react';
import { isEqual, debounce } from 'lodash-es';
import validator from '../../validators/survey-parts';
import { SurveySchemaPartEditorType } from '../../constants/types';

const WithSurveyPartValidation = (WrappedComponent) =>
  class extends Component {
    // eslint-disable-next-line react/static-property-placement
    static propTypes = {
      surveySchemaPart: SurveySchemaPartEditorType.isRequired
    };

    constructor(props) {
      super(props);

      this.validate = debounce(() => this.setState(validator(this.props)), 300);

      this.state = {
        invalidFields: [],
        isValid: true
      };
    }

    componentDidMount() {
      this.setState(validator(this.props));
    }

    componentDidUpdate(prevProps) {
      if (!isEqual(prevProps.surveySchemaPart, this.props.surveySchemaPart)) {
        this.validate();
      }
    }

    render() {
      return (
        <WrappedComponent
          isValid={this.state.isValid}
          invalidFields={this.state.invalidFields}
          {...this.props}
        />
      );
    }
  };

export default WithSurveyPartValidation;
